var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB4Calendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 13h-6v4.44a5 5 0 11-10 0V13H30v4.44a5 5 0 11-10 0V13h-6.25A4 4 0 0010 16.61V62a4 4 0 003.88 4h48.37A4 4 0 0066 62V16.61A4 4 0 0062 13zm.09 49H13.88V26h48.21v36zM49 17.44V9a2 2 0 114 0v8.44a2 2 0 01-4 0zm-26 0V9a2 2 0 114 0v8.44a2 2 0 01-4 0zM57 56H47v-4h10v4zm0-9H47v-4h10v4zm0-9H47v-4h10v4zM43 56H33v-4h10v4zm0-9H33v-4h10v4zm0-9H33v-4h10v4zM29 56H19v-4h10v4zm0-9H19v-4h10v4zm0-9H19v-4h10v4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B4_Calendar.3a5c1a62.svg";
export { SvgB4Calendar as ReactComponent };